// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as LumiDrawCommand from "lumi-draw-command/lib/es6/src/LumiDrawCommand.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Display$LumiDocuments from "lumi-documents/lib/es6/src/Display.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as ObjectStyle$LumiFacilityMap from "./ObjectStyle.res.js";

function make(objectStyleOpt, contents) {
  let objectStyle = objectStyleOpt !== undefined ? objectStyleOpt : ObjectStyle$LumiFacilityMap.empty;
  return {
    objectStyle: objectStyle,
    contents: contents
  };
}

function lastDrawCommandContents(mbDisplayStateDoc) {
  return LumiReact.renderOption(undefined, Stdlib_Option.flatMap(mbDisplayStateDoc, displayStateDoc => Document$LumiStore.contents(displayStateDoc).lastUpdate), param => param.this.drawCommands.map((command, commandIndex) => JsxRuntime.jsx(LumiDrawCommand.LumiDrawCommand.SVG.make, {
    command: command
  }, commandIndex.toString())));
}

function makeFromDisplay(objectStyleOpt, displayWithState) {
  let objectStyle = objectStyleOpt !== undefined ? objectStyleOpt : ObjectStyle$LumiFacilityMap.empty;
  let boundingBox = Display$LumiDocuments.Display.boundingBox(Document$LumiStore.contents(displayWithState[0]));
  let element = lastDrawCommandContents(displayWithState[1]);
  return make(objectStyle, {
    boundingBox: boundingBox,
    element: element
  });
}

let objectStyle = ObjectStyle$LumiFacilityMap.empty;

let empty = {
  objectStyle: objectStyle,
  contents: undefined
};

function merge(a, b) {
  return {
    objectStyle: ObjectStyle$LumiFacilityMap.merge(a.objectStyle, b.objectStyle),
    contents: Stdlib_Option.orElse(a.contents, b.contents)
  };
}

function mergeOpt(mbA, mbB) {
  return LumiOption.unionWith(merge, mbA, mbB);
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  make,
  lastDrawCommandContents,
  makeFromDisplay,
  empty,
  merge,
  mergeOpt,
}
/* LumiReact Not a pure module */
